<template>
  <div class="login-container">
    <div id="container" class="container">
      <div class="form-container sign-up-container">
        <div class="qcode-box">
          <h1>扫码登录</h1>
          <p>打开慕鹿APP扫一扫</p>
          <div class="login-qrcode" v-loading="isQCodeLoading">
            <div id="qrcode" ref="qrcode" ></div>
            <div class="qrcode-error" v-if="isQCodeError == true">
              <p>获取二维码失败</p>
              <el-button @click="getScanCodeLogin()" type="primary" icon="el-icon-refresh-right" round>重新获取</el-button>
            </div>
            <div class="qrcode-expired" v-if="isQCodeExpired == true">
              <p>该二维码已失效</p>
              <el-button @click="getScanCodeLogin()" type="primary" icon="el-icon-refresh-right" round>重新获取</el-button>
            </div>
            <div class="qrcode-success" v-if="isQCodeSuccess == true">
              <p><i class="el-icon-success"></i> 扫码成功，正在登录</p>
            </div>
          </div>
<!--          <img src="@/assets/login/qrcode_mulu.jpg" style="width:260px;height: 260px;">-->
        </div>
      </div>
      <div class="form-container sign-in-container">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
          <h1>账号登录</h1>
          <div class="social-container">
            <!-- <a href="javascript:;" class="social" title="微信登录" @click="showWChatDialog"><svg-icon icon-class="wechat" /></a> -->
            <!-- <a href="javascript:;" class="social" title="支付宝登录" @click="showALiDialog"><svg-icon icon-class="alipay"/></a> -->
            <a href="javascript:;" class="social" v-if="logintype == false" @click="logintype = true" title="验证码登录"><svg-icon icon-class="phone" /></a>
            <a href="javascript:;" class="social" v-if="logintype == true" @click="logintype = false" title="密码登录"><svg-icon icon-class="paw" /></a>
          </div>
          <span>其他方式登录</span>
          <el-form-item prop="username">
            <el-input
              ref="username"
              v-model="loginForm.username"
              placeholder="手机号码"
              name="username"
              maxlength="11"
              minlength="11"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="code" v-if="logintype == true">
            <el-input
              ref="code"
              v-model="loginForm.code"
              placeholder="验证码"
              name="code"
              maxlength="6"
              minlength="6"
              type="text"
              tabindex="2"
              auto-complete="on"
            />
            <el-button type="text" :disabled="isDisabledLoginCode" :loading="isCodeLoadingLogin" @click="getCodeLogin()" style="position: absolute;right:10px;font-size:13px;">{{codeBtnLogin}}</el-button>
          </el-form-item>
          <el-form-item prop="password" v-if="logintype == false">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              :type="passwordType"
              placeholder="登录密码"
              name="password"
              tabindex="2"
              minlength="6"
              maxlength="16"
              auto-complete="on"
              @keyup.enter.native="handleLogin"
            />
            <span class="show-pwd" @click="showPwd">
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>
          <el-button :loading="loading" type="primary" style="padding: 12px 45px;border-radius: 20px;font-size: 12px;font-weight: bold;letter-spacing: 1px;margin-top: 10px;" @click.native.prevent="handleLogin">登录</el-button>
          <div class="other-options">
            <el-button type="text" class="reg-user" @click="regVisible = true">注册用户</el-button>
            <el-button type="text" class="forget-paw" @click="forgetPawVisible = true">忘记密码？</el-button>
          </div>
        </el-form>
      </div>
      <div class="overlay-container">
        <div class="overlay">
          <div class="overlay-panel overlay-left">
            <h1>未安装慕鹿？</h1>
            <p>请点击下载<a href="https://www.mulu.life/" style="font-weight: bold;" target="_blank">慕鹿APP</a>，你还可以选择账号登录</p>
            <el-button class="ghost" @click="signIn">账号登录</el-button>
          </div>
          <div class="overlay-panel overlay-right">
            <img src="@/assets/login/mulu-logo_400.png" style="width:100px;height: 100px;">
            <h1>慕鹿生态系统</h1>
            <p>使用慕鹿APP扫一扫</p>
            <el-button class="ghost" @click="signUp">扫码登录</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      :visible.sync="regVisible"
      direction="rtl">
      <div style="width: 100%;padding: 0 20px">
        <el-tabs>
          <el-tab-pane label="企业员工用户注册" style="padding-top:20px;">
            <el-form ref="staffRegForm" status-icon :rules="regRules" :model="staffRegForm" label-width="80px">
              <el-form-item label="所在组织" prop="group">
                <el-cascader
                  style="width: 100%"
                  v-model="staffRegForm.group"
                  change-on-select
                  :options="groupoptions"
                  @change="isFactory"
                  :props="{ checkStrictly: true }"
                  filterable></el-cascader>
              </el-form-item>
              <el-form-item v-if="isOut===0" label="当前职位" prop="positionid">
                <el-cascader
                  style="width: 100%"
                  v-model="staffRegForm.positionid"
                  :options="positionoptions"
                  :show-all-levels="false"
                  filterable></el-cascader>
              </el-form-item>
              <el-form-item v-if="isOut===1" label="当前职位" prop="positionid">
                <el-select v-model="staffRegForm.positionid" placeholder="请选择">
                  <el-option
                    v-for="item in positionoptionsCopy"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="真实姓名" prop="name">
                <el-input v-model="staffRegForm.name" maxlength="6" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="username">
                <el-input v-model="staffRegForm.username" maxlength="11" minlength="11" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code">
                <el-col :span="11">
                  <el-input v-model="staffRegForm.code" maxlength="6" minlength="6" autocomplete="off"></el-input>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="12">
                  <el-button :disabled="isDisabledCode" :loading="isCodeLoading" @click="getCode()">{{codeBtn}}</el-button>
                </el-col>
              </el-form-item>
              <el-form-item label="登录密码" prop="password">
                <el-input type="password" minlength="6" maxlength="16" v-model="staffRegForm.password" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="isStaffLoading" @click="submitRegForm('staffRegForm')">立即注册</el-button>
                <el-button @click="resetRegForm('staffRegForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="经销商用户注册" style="padding-top:20px;">
            <el-form ref="delRegForm" status-icon :rules="regDelRules" :model="delRegForm" label-width="80px">
              <el-form-item label="所在地区" prop="area">
                <el-cascader
                  ref="delArea"
                  style="width: 100%"
                  v-model="delRegForm.area"
                  :options="cityoptions"
                  @change="changeArea"
                  filterable></el-cascader>
              </el-form-item>
              <el-form-item label="经销商" prop="delid">
                <el-select v-model="delRegForm.delid" placeholder="请选择经销商" style="width: 100%">
                  <el-option
                    v-for="item in deloptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="真实姓名" prop="name">
                <el-input v-model="delRegForm.name" maxlength="6" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="username">
                <el-input v-model="delRegForm.username" maxlength="11" minlength="11" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code">
                <el-col :span="11">
                  <el-input v-model="delRegForm.code" maxlength="6" minlength="6" autocomplete="off"></el-input>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="12">
                  <el-button :disabled="isDisabledCodeDel" :loading="isCodeLoadingDel" @click="getCodeDel()">{{codeBtnDel}}</el-button>
                </el-col>
              </el-form-item>
              <el-form-item label="登录密码" prop="password">
                <el-input type="password" minlength="6" maxlength="16" v-model="delRegForm.password" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="isDelLoading" @click="submitRegForm('delRegForm')">立即注册</el-button>
                <el-button @click="resetRegForm('delRegForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      title="忘记密码"
      :visible.sync="forgetPawVisible"
      direction="rtl">
      <div style="width: 100%;padding: 20px">
        <el-form ref="pawForm" status-icon :rules="pawRules" :model="pawForm" label-width="80px">
          <el-form-item label="手机号码" prop="username">
            <el-input v-model="pawForm.username" maxlength="11" minlength="11" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-col :span="11">
              <el-input v-model="pawForm.code" maxlength="6" minlength="6" autocomplete="off"></el-input>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="12">
              <el-button :disabled="isDisabledCodePaw" :loading="isCodeLoadingPaw" @click="getCodePaw()">{{codeBtnPaw}}</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" minlength="6" maxlength="16" v-model="pawForm.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkpassword">
            <el-input type="password" minlength="6" maxlength="16" v-model="pawForm.checkpassword" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="isPawLoading" @click="submitPawForm('pawForm')">立即提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-dialog
      title="支付宝扫码登录"
      :visible.sync="aLiDialog"
      :before-close="closeALiPayTimer"
      width="300px">
      <div style="height: 270px;padding: 20px 0 0 35px;" v-loading="aLiLoading">
        <div ref="aLiPayLogin" id="aLiPayLogin"/>
        <div class="pay-error" v-if="aLiPayBad === true">
          <p>获取二维码失败</p>
          <el-button @click="showALiDialog()" type="primary" icon="el-icon-refresh-right" round>重新获取</el-button>
        </div>
        <div class="pay-expired" v-if="aLiPayTimeOut === true" >
          <p style="margin-top:70px;">该二维码已失效</p>
          <el-button style="margin-top: 20px;" @click="showALiDialog()" type="primary" icon="el-icon-refresh-right" round>重新获取</el-button>
        </div>
        <div class="pay-success" v-if="aLiPaySuccess === true">
          <p><i class="el-icon-success"/> 扫码成功，正在登录</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="微信扫码登录"
      :visible.sync="wChatDialog"
      :before-close="closeWChatTimer"
      width="330px">
      <wxlogin :appid="appid" :scope="wxScope" :redirect_uri="redirect_uri"  :state="wxState"/>
    </el-dialog>
  </div>
</template>
<script>
import { validatePhoneNumber } from '@/utils/validate'
import { getGroupTree, getPositionTree, getSMSCode, checkUser, register, getDealerListByArea, checkDealerUser, registerDealer, forgetPassword, getScanCodeLoginToken, checkScanCodeLoginTokenBindUser, getALiPayToken, checkALiPayToken, getWChatToken, checkWChatToken, getWchatOpenIdByCode } from '@/api/pub'
import { getCity } from '@/utils/city'
import QRCode from 'qrcodejs2'
import wxlogin from 'vue-wxlogin'
import { getUrlKey } from '@/utils/index'

export default {
  name: 'Login',
  components: {
    wxlogin
  },
  data() {
    const validateLoginUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        this.isDisabledLoginCode = true
        callback(new Error('请输入正确的手机号码'))
      } else {
        this.isDisabledLoginCode = false
        callback()
      }
    }
    const validateUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        this.isDisabledCode = true
        callback(new Error('请输入正确的手机号码'))
      } else {
        this.isDisabledCode = false
        callback()
      }
    }
    const validateUsernameDel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        this.isDisabledCodeDel = true
        callback(new Error('请输入正确的手机号码'))
      } else {
        this.isDisabledCodeDel = false
        callback()
      }
    }
    const validateUsernamePaw = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        this.isDisabledCodePaw = true
        callback(new Error('请输入正确的手机号码'))
      } else {
        this.isDisabledCodePaw = false
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入6-16位的登录密码'))
      } else {
        callback()
      }
    }
    const validatePassword2 = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入6-16位的登录密码'))
      } else {
        if (value !== this.pawForm.password) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      }
    }
    return {
      isScanCode: false,
      qrcode: null,
      qcodetoken: '',
      isDisabledLoginCode: true,
      isQCodeLoading: false,
      isQCodeError: false,
      isQCodeExpired: false,
      isQCodeSuccess: false,
      qcodeTimer: '',
      checkLogin: '',
      codeBtnLogin: '获取验证码',
      isCodeLoadingLogin: false,
      codeTimerLogin: '',
      soundsLogin: 60,
      loginForm: {
        username: '',
        password: '',
        ip: '',
        code: '',
        msg_id: '',
        type: 0,
        aLiPayId: '',
        wChatOpenId: '',
        wChatUnionId: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateLoginUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        code: [{ required: true, message: '请输入6位短信验证码', trigger: 'blur' }],
      },
      logintype: false,
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      regVisible: false,
      forgetPawVisible: false,
      groupoptions: [],
      positionoptions: [],
      positionoptionsCopy: [],
      isStaffLoading: false,
      codeBtn: '获取验证码',
      isCodeLoading: false,
      isDisabledCode: true,
      codeTimer: '',
      sounds: 60,
      checkphone: '',
      staffRegForm: {
        group: [],
        positionid: [],
        name: '',
        username: '',
        code: '',
        password: '',
        msg_id: ''
      },
      regRules: {
        group: [{ type: 'array', required: true, message: '请选择所在组织的部门', trigger: 'change' }],
        positionid: [{ required: true, message: '请选择您的职位', trigger: 'change' }],
        name: [{ required: true, message: '请输入您的真实姓名', trigger: 'blur' }],
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        code: [{ required: true, message: '请输入6位短信验证码', trigger: 'blur' }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      cityoptions: getCity(),
      deloptions: [],
      isDelLoading: false,
      codeBtnDel: '获取验证码',
      isCodeLoadingDel: false,
      isDisabledCodeDel: true,
      codeTimerDel: '',
      soundsDel: 60,
      checkphoneDel: '',
      delRegForm: {
        area: [],
        delid: '',
        name: '',
        username: '',
        code: '',
        password: '',
        msg_id: ''
      },
      regDelRules: {
        delid: [{ required: true, message: '请选择所属经销商', trigger: 'blur' }],
        area: [{ type: 'array', required: true, message: '请选择经销商所在地区', trigger: 'blur' }],
        name: [{ required: true, message: '请输入您的真实姓名', trigger: 'blur' }],
        username: [{ required: true, trigger: 'blur', validator: validateUsernameDel }],
        code: [{ required: true, message: '请输入6位短信验证码', trigger: 'blur' }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      isPawLoading: false,
      codeBtnPaw: '获取验证码',
      isCodeLoadingPaw: false,
      isDisabledCodePaw: true,
      codeTimerPaw: '',
      soundsPaw: 60,
      checkphonePaw: '',
      pawForm: {
        username: '',
        code: '',
        password: '',
        checkpassword: '',
        msg_id: ''
      },
      pawRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsernamePaw }],
        code: [{ required: true, message: '请输入6位短信验证码', trigger: 'blur' }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        checkpassword: [{ required: true, trigger: 'blur', validator: validatePassword2 }]
      },
      aLiDialog: false,
      aLiLoading: false,
      aLiPayLogin: null,
      aLiPayToken: null,
      aLiPayTimer: null,
      aLiPayTimeOut: false,
      aLiPayBad: false,
      aLiPaySuccess: false,
      wChatDialog: false,
      wChatLoading: false,
      wChatTimer: null,
      wxState: null,
      wChatTimeOut: false,
      wChatBad: false,
      wChatSuccess: false,
      appid: 'wx48ffbf1de47b1986',
      wxScope: 'snsapi_login',
      redirect_uri: 'https://www.mulu.life/elichain/login',
      isOut: 0
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    const code = getUrlKey('code')
    const state = getUrlKey('state')
    if (code !== null && code !== '' && code !== undefined && state !== null && state !== '' && state !== undefined) {
      // 代表微信授权成功
      const wxloginLoading = this.$loading({
        lock: true,
        text: '微信登录中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      getWchatOpenIdByCode({ code: code }).then(response => {
        if (response.data !== undefined && response.data !== null) {
          // 正在登录，PC第三方登陆，显示正在登陆
          this.loginForm.ip = localStorage.getItem('Ip')
          this.loginForm.wChatOpenId = response.data.openid
          this.loginForm.wChatUnionId = response.data.unionid
          this.loginForm.type = 4
          this.$store.dispatch('user/login', this.loginForm).then(() => {
            wxloginLoading.close()
            this.$router.push({ path: this.redirect || '/' })
          }).catch(() => {
            wxloginLoading.close()
          })
        } else {
          this.$message.error('微信登录失败')
          wxloginLoading.close()
        }
      }).catch(res => {
        wxloginLoading.close()
      })
    }
    getGroupTree().then(response => {
      if (!response.success) {
        this.$message({
          type: 'error',
          message: response.msg
        })
      } else {
        this.groupoptions = response.data
      }
    }).catch(() => {
    })
    getPositionTree().then(response => {
      if (!response.success) {
        this.$message({
          type: 'error',
          message: response.msg
        })
      } else {
        this.positionoptions = response.data
        let data = []
        for (const item of this.positionoptions) {
          if (item.value === 50) {
            for (const i of item.children) {
              if (i.value === 67) {
                data = i.children
              }
            }
          }
        }
        this.positionoptionsCopy = data
      }
    }).catch(() => {
    })
  },
  methods: {
    isFactory(val) {
      // 如果值相等且是工厂 如果是一车间
      if (val[0] === 'group@3' || val[0] === 'group@1' || val[0] === 'group@2' || val[0] === 'group@35') {
        if (this.isOut !== 0) {
          this.staffRegForm.positionid = []
        }
        this.isOut = 0
      } else {
        if (this.isOut !== 1) {
          this.staffRegForm.positionid = ''
        }
        this.isOut = 1
      }
    },
    changeArea() {
      const data = {
        province: this.delRegForm.area[0],
        city: this.delRegForm.area[1],
        county: this.delRegForm.area[2]
      }
      this.delRegForm.delid = null
      getDealerListByArea(data).then(response => {
        let option = []
        for (let del of response.data) {
          option.push({ value: del.delid, label: del.allname })
        }
        this.deloptions = option
      }).catch(() => {
        this.deloptions = []
      })
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.loginForm.ip = localStorage.getItem('Ip')
          if (this.logintype) {
            this.loginForm.type = 1
          }
          this.$store.dispatch('user/login', this.loginForm).then(() => {
            this.$router.push({ path: this.redirect || '/' })
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    signUp() {
      document.getElementById('container').classList.add('right-panel-active')
      this.isScanCode = true
      this.getScanCodeLogin()
    },
    signIn() {
      document.getElementById('container').classList.remove('right-panel-active')
      this.isScanCode = false
      this.$refs.qrcode.innerHTML = ''
      this.isQCodeExpired = false
      this.qcodetoken = ''
      clearInterval(this.qcodeTimer)
    },
    getScanCodeLogin() {
      this.$refs.qrcode.innerHTML = ''
      this.qcodetoken = ''
      this.isQCodeLoading = true
      this.isQCodeError = false
      this.isQCodeExpired = false
      getScanCodeLoginToken().then(response => {
        this.qcodetoken = response.data
        this.qrcode = new QRCode('qrcode', {
          width: 220,
          height: 220,
          text: 'https://www.mulu.life/?qcodeLogin=' + response.data,
          colorDark: '#000',
          colorLight: '#fff'
        })
        this.isQCodeLoading = false
        this.qcodeTimer = setInterval(this.countdownScanCodeLogin, 1000)
      }).catch(() => {
        this.isQCodeLoading = false
        this.isQCodeError = true
      })
    },
    countdownScanCodeLogin() {
      const data = { token: this.qcodetoken }
      checkScanCodeLoginTokenBindUser(data).then(response => {
        if (response.status === '99') {
          this.isQCodeExpired = true
          this.qcodetoken = ''
          clearInterval(this.qcodeTimer)
        } else if (response.status === '1') {
          clearInterval(this.qcodeTimer)
          this.qcodetoken = ''
          this.isQCodeSuccess = true
          this.loginForm.ip = localStorage.getItem('Ip')
          this.loginForm.username = response.data.username
          this.loginForm.type = 2
          this.$store.dispatch('user/login', this.loginForm).then(() => {
            this.$router.push({ path: this.redirect || '/' })
          }).catch(() => {
            this.isQCodeExpired = true
          })
        }
      }).catch(() => {
        this.isQCodeExpired = true
        this.qcodetoken = ''
        clearInterval(this.qcodeTimer)
      })
    },
    getCode() {
      if (!this.isDisabledCode) {
        if (this.sounds === 60) {
          this.isCodeLoading = true
          getSMSCode(this.staffRegForm.username).then(response => {
            this.checkphone = this.staffRegForm.username
            this.isCodeLoading = false
            this.staffRegForm.msg_id = response.data.msg_id
            this.isDisabledCode = true
            this.codeTimer = setInterval(this.countdown, 1000)
          }).catch(() => {
            this.isCodeLoading = false
          })
        } else {
          this.isDisabledCode = true
        }
      }
    },
    countdown() {
      this.sounds--
      if (this.sounds === 0) {
        clearInterval(this.codeTimer)
        this.codeBtn = '获取验证码'
        this.isDisabledCode = false
        this.sounds = 60
      } else {
        this.codeBtn = '重新获取 ' + this.sounds
      }
    },
    getCodeDel() {
      if (!this.isDisabledCodeDel) {
        if (this.soundsDel === 60) {
          this.isCodeLoadingDel = true
          getSMSCode(this.delRegForm.username).then(response => {
            this.checkphoneDel = this.delRegForm.username
            this.isCodeLoadingDel = false
            this.delRegForm.msg_id = response.data.msg_id
            this.isDisabledCodeDel = true
            this.codeTimerDel = setInterval(this.countdownDel, 1000)
          }).catch(() => {
            this.isCodeLoadingDel = false
          })
        } else {
          this.isDisabledCodeDel = true
        }
      }
    },
    countdownDel() {
      this.soundsDel--
      if (this.soundsDel === 0) {
        clearInterval(this.codeTimerDel)
        this.codeBtnDel = '获取验证码'
        this.isDisabledCodeDel = false
        this.soundsDel = 60
      } else {
        this.codeBtnDel = '重新获取 ' + this.soundsDel
      }
    },
    getCodePaw() {
      if (!this.isDisabledCodePaw) {
        if (this.soundsPaw === 60) {
          this.isCodeLoadingPaw = true
          getSMSCode(this.pawForm.username).then(response => {
            this.checkphonePaw = this.pawForm.username
            this.isCodeLoadingPaw = false
            this.pawForm.msg_id = response.data.msg_id
            this.isDisabledCodePaw = true
            this.codeTimerPaw = setInterval(this.countdownPaw, 1000)
          }).catch(() => {
            this.isCodeLoadingPaw = false
          })
        } else {
          this.isDisabledCodePaw = true
        }
      }
    },
    countdownPaw() {
      this.soundsPaw--
      if (this.soundsPaw === 0) {
        clearInterval(this.codeTimerPaw)
        this.codeBtnPaw = '获取验证码'
        this.isDisabledCodePaw = false
        this.soundsPaw = 60
      } else {
        this.codeBtnPaw = '重新获取 ' + this.soundsPaw
      }
    },
    getCodeLogin() {
      if (!this.isDisabledLoginCode) {
        if (this.soundsLogin === 60) {
          this.isCodeLoadingLogin = true
          getSMSCode(this.loginForm.username).then(response => {
            this.checkLogin = this.loginForm.username
            this.isCodeLoadingLogin = false
            this.loginForm.msg_id = response.data.msg_id
            this.isDisabledLoginCode = true
            this.codeTimerLogin = setInterval(this.countdownLogin, 1000)
          }).catch(() => {
            this.isCodeLoadingLogin = false
          })
        } else {
          this.isDisabledLoginCode = true
        }
      }
    },
    countdownLogin() {
      this.soundsLogin--
      if (this.soundsLogin === 0) {
        clearInterval(this.codeTimerLogin)
        this.codeBtnLogin = '获取验证码'
        this.isDisabledLoginCode = false
        this.soundsLogin = 60
      } else {
        this.codeBtnLogin = '重新获取 ' + this.soundsLogin
      }
    },
    submitRegForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 企业员工注册
          if (formName === 'staffRegForm') {
            if (this.checkphone === this.staffRegForm.username) {
              if (!this.isStaffLoading) {
                let deptid = this.staffRegForm.group[this.staffRegForm.group.length - 1]
                if (deptid.indexOf('group') >= 0) {
                  this.$message.error('请选择所在组织的部门')
                  return false
                }
                // 临时转移数据使用----------
                let groupid = this.staffRegForm.group[0]
                if (groupid.indexOf('group') >= 0) {
                  groupid = groupid.split('@')[1]
                }
                if (deptid.indexOf('dept') >= 0) {
                  deptid = deptid.split('@')[1]
                }
                // ------------------------
                this.isStaffLoading = true
                let positionid = ''
                if (this.isOut === 1) {
                  positionid = this.staffRegForm.positionid
                } else {
                  positionid = this.staffRegForm.positionid[2]
                }
                const data = {
                  username: this.staffRegForm.username,
                  password: this.staffRegForm.password,
                  msg_id: this.staffRegForm.msg_id,
                  code: this.staffRegForm.code,
                  // 临时转移数据使用------
                  realName: this.staffRegForm.name,
                  groupid: groupid,
                  deptid: deptid,
                  positionid: positionid
                  // -----------------------
                }
                checkUser(data).then(response => {
                  if (response.status === '202') {
                    let groupid = this.staffRegForm.group[0]
                    if (groupid.indexOf('group') >= 0) {
                      groupid = groupid.split('@')[1]
                    }
                    if (deptid.indexOf('dept') >= 0) {
                      deptid = deptid.split('@')[1]
                    }
                    const regdata = {
                      realName: this.staffRegForm.name,
                      groupid: groupid,
                      deptid: deptid,
                      positionid: positionid,
                      username: this.staffRegForm.username,
                      password: this.staffRegForm.password
                    }
                    register(regdata).then(response => {
                      this.regVisible = false
                      this.$refs[formName].resetFields()
                      this.isStaffLoading = false
                      this.$message({
                        message: '注册成功，审核成功后将以短信方式通知您',
                        showClose: true,
                        duration: 10000,
                        type: 'success'
                      })
                    }).catch(() => {
                      this.isStaffLoading = false
                    })
                  } else {
                    this.$message({
                      message: '注册成功，请登录',
                      type: 'success'
                    })
                    this.regVisible = false
                    this.$refs[formName].resetFields()
                    this.isStaffLoading = false
                  }
                }).catch(() => {
                  this.isStaffLoading = false
                })
              } else {
                return false
              }
            } else {
              this.$message.error('手机号码验证失败')
              return false
            }
          } else {
            // 经销商用户注册
            if (this.checkphoneDel === this.delRegForm.username) {
              if (!this.isDelLoading) {
                this.isDelLoading = true
                const data = {
                  username: this.delRegForm.username,
                  password: this.delRegForm.password,
                  msg_id: this.delRegForm.msg_id,
                  code: this.delRegForm.code
                }
                checkDealerUser(data).then(response => {
                  if (response.status === '202') {
                    const regdata = {
                      realName: this.delRegForm.name,
                      delid: this.delRegForm.delid,
                      username: this.delRegForm.username,
                      password: this.delRegForm.password
                    }
                    registerDealer(regdata).then(response => {
                      this.regVisible = false
                      this.$refs[formName].resetFields()
                      this.isDelLoading = false
                      this.$message({
                        message: '注册成功，审核成功后将以短信方式通知您',
                        showClose: true,
                        duration: 10000,
                        type: 'success'
                      })
                    }).catch(() => {
                      this.isDelLoading = false
                    })
                  } else {
                    this.$message({
                      message: '注册成功，请登录',
                      type: 'success'
                    })
                    this.regVisible = false
                    this.$refs[formName].resetFields()
                    this.isDelLoading = false
                  }
                }).catch(() => {
                  this.isDelLoading = false
                })
              } else {
                return false
              }
            } else {
              this.$message.error('手机号码验证失败')
              return false
            }
          }
        } else {
          return false
        }
      })
    },
    resetRegForm(formName) {
      this.$refs[formName].resetFields()
    },
    submitPawForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checkphonePaw === this.pawForm.username) {
            const data = {
              username: this.pawForm.username,
              password: this.pawForm.password,
              msg_id: this.pawForm.msg_id,
              code: this.pawForm.code
            }
            forgetPassword(data).then(response => {
              this.forgetPawVisible = false
              this.$refs[formName].resetFields()
              this.isPawLoading = false
              this.$message({
                message: '密码修改成功',
                type: 'success'
              })
            }).catch(() => {
              this.isPawLoading = false
            })
          } else {
            this.$message.error('手机号码验证失败')
            return false
          }
        } else {
          return false
        }
      })
    },
    showALiDialog(){
      this.aLiDialog = true
      this.aLiLoading = true
      getALiPayToken().then(response => {
        this.$refs.aLiPayLogin.innerHTML = ''
        this.aLiPayToken = response.data
        let redirectUrl = `${this.$store.state.settings.ApiPath}api/getALiPayLogin?aLiPayToken=${this.aLiPayToken}`
        const url = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2019102468626149&scope=auth_user&redirect_uri=${redirectUrl}`
        this.aLiPayLogin = new QRCode('aLiPayLogin', {
          width: 200,
          height: 200,
          text: url,
          colorDark: '#000',
          colorLight: '#fff'
        })
        this.aLiLoading = false
        this.findALiPayToken()
      }).catch(() => {
        this.aLiLoading = false
        this.aLiPayBad = true
      })
    },
    findALiPayToken() {
      const _this = this
      _this.aLiPayTimer = setInterval(function() {
        checkALiPayToken({ token: _this.aLiPayToken }).then(response => {
          if (response.data !== undefined && response.data !== null) {
            if (_this.aLiPayTimer !== null) {
              clearInterval(_this.aLiPayTimer)
              _this.aLiPayTimer = null
            }
            // 正在登录，PC第三方登陆，显示正在登陆
            _this.aLiPaySuccess = true
            _this.loginForm.ip = localStorage.getItem('Ip')
            _this.loginForm.aLiPayId = response.data
            _this.loginForm.type = 3
            _this.$store.dispatch('user/login', _this.loginForm).then(() => {
              _this.$router.push({ path: _this.redirect || '/' })
            }).catch(() => {
              _this.aLiPayBad = true
            })
          }
        }).catch(()=>{
          if(_this.aLiPayTimer!==null) {
            clearInterval(_this.aLiPayTimer)
            _this.aLiPayTimer = null
          }
          this.aLiPayBad = true
        })
      }, 1000)
    },
    closeALiPayTimer(done) {
      if(this.aLiPayTimer !== null) {
        clearInterval(this.aLiPayTimer)
        this.aLiPayTimer = null
      }
      this.aLiPayTimeOut = false
      this.aLiPayBad = false
      this.aLiPaySuccess = false
      this.loginForm.aLiPayId = ''
      this.loginForm.type = 0
      done();
    },
    showWChatDialog() {
      this.wxState = new Date().getTime().toString()
      this.wChatDialog = true
    },
    findWChatToken() {
      const _this = this
      _this.wChatTimer = setInterval(function() {
        checkWChatToken({ token: _this.wxState }).then(response => {
          if (response.data !== undefined && response.data !== null) {
            if (_this.wChatTimer !== null) {
              clearInterval(_this.wChatTimer)
              _this.wChatTimer = null
            }
            // console.log(response.data)
            // 正在登录，PC第三方登陆，显示正在登陆
            _this.loginForm.ip = localStorage.getItem('Ip')
            _this.loginForm.wChatOpenId = response.data.openid
            _this.loginForm.wChatUnionId = response.data.unionid
            _this.loginForm.type = 4
            _this.$store.dispatch('user/login', _this.loginForm).then(() => {
              _this.$router.push({ path: _this.redirect || '/' })
            }).catch(() => {
              _this.wChatDialog = false
            })
          }
        })
      }, 1000)
    },
    closeWChatTimer(done) {
      if (this.wChatTimer !== null) {
        clearInterval(this.wChatTimer)
        this.wChatTimer = null
      }
      this.wChatTimeOut = false
      this.wChatBad = false
      this.wChatSuccess = false
      this.loginForm.aLiPayId = ''
      this.loginForm.wChatUnionId = ''
      this.loginForm.wChatOpenId = ''
      this.loginForm.type = 0
      done()
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg:#283443;
$light_gray:#fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .sign-in-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .sign-in-container{
    .el-input {
      width: 100%;
      background-color: #eee;
      border: none;
      padding:0 30px 0 15px;

      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        color: #000000;
        font-size: 13px;
        padding: 0;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px $bg inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
      }
    }
    .el-form-item {
      width: 100%;
      margin: 8px 0 10px 0
    }
  }
}
</style>

<style lang="scss" scoped>
$bg:#2d3a4b;
$dark_gray:#c5c7c9;
$light_gray:#eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background: #f6f5f7 url(~@/assets/login/login-background.svg) no-repeat center 110px;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    font-weight: bold;
    margin: 0;
  }

  span {
    font-size: 12px;
  }

  .container {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 14px 28px #ccc, 0 10px 10px #ccc;
    position: relative;
    overflow: hidden;
    width: 768px;
    max-width: 100%;
    min-height: 480px;

    .login-qrcode{
      width: 260px;
      height: 260px;
      position: relative;
      padding: 20px;

      .qrcode-error{
        width: 220px;
        height: 220px;
        position: absolute;
        top: 20px;
        left: 20px;
        padding-top: 70px;
      }

      .qrcode-expired{
        width: 220px;
        height: 220px;
        position: absolute;
        top: 20px;
        left: 20px;
        padding-top: 70px;
        background: rgba(255,255,255,0.9);
      }

      .qrcode-success{
        width: 220px;
        height: 220px;
        position: absolute;
        top: 20px;
        left: 20px;
        line-height: 200px;
        background: #fff;
        color:#67C23A;
      }
    }

    .form-container {
      position: absolute;
      top: 0;
      height: 100%;
      transition: all 0.6s ease-in-out;
    }

    .sign-up-container {
      left: 0;
      width: 50%;
      opacity: 0;
      z-index: 1;

      .qcode-box{
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 50px;
        height: 100%;
        text-align: center;
      }
    }

    .sign-in-container {
      left: 0;
      width: 50%;
      z-index: 2;
    }
    .overlay-container {
      position: absolute;
      top: 0;
      left: 50%;
      width: 50%;
      height: 100%;
      overflow: hidden;
      transition: transform 0.6s ease-in-out;
      z-index: 100;
    }
  }

  .login-form {
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 50px;
    height: 100%;
    text-align: center;

    .social-container {
      margin: 20px 0;

      a {
        border: 1px solid #DDDDDD;
        border-radius: 50%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin: 0 5px;
        height: 40px;
        width: 40px;
      }
    }
  }

  .svg-container {
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    position: absolute;
    z-index: 1;
    margin-left: 2px;
    padding-top: 1px;
  }
  .icon-phone{
    font-size: 16px;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 2px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
    .svg-icon{
      width: 1em;
      height: 1em;
      vertical-align: -0.15em;
      color: #c5c7c9;
    }
  }

  .other-options{
    margin: 20px 0 10px 0;
    position: relative;
    width: 100%;
    .reg-user{
      margin-right: 10px;
      color: #333;
      font-size: 13px;
    }
    .forget-paw{
      color: #333;
      font-size: 13px;
    }
  }

  .overlay-container {
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
    height: 100%;
    overflow: hidden;
    transition: transform 0.6s ease-in-out;
    z-index: 100;

    .overlay {
      background: #4385f7;
      background: -webkit-linear-gradient(to right, #50a6f8, #4385f7);
      background: linear-gradient(to right, #50a6f8, #4385f7);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 0 0;
      color: #FFFFFF;
      position: relative;
      left: -100%;
      height: 100%;
      width: 200%;
      transform: translateX(0);
      transition: transform 0.6s ease-in-out;

      .overlay-panel {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 40px;
        text-align: center;
        top: 0;
        height: 100%;
        width: 50%;
        transform: translateX(0);
        transition: transform 0.6s ease-in-out;

        p {
          font-size: 14px;
          font-weight: 300;
          line-height: 20px;
          letter-spacing: 0.5px;
          margin: 20px 0 30px;
        }
        button.ghost {
          border-radius: 20px;
          background-color: transparent;
          order-radius: 20px;
          border: 1px solid #FFFFFF;
          color: #FFFFFF;
          font-size: 12px;
          font-weight: bold;
          padding: 12px 45px;
          letter-spacing: 1px;
          text-transform: uppercase;
          transition: transform 80ms ease-in;
        }
      }

      .overlay-left {
        transform: translateX(-20%);
      }

      .overlay-right {
        right: 0;
        transform: translateX(0);
      }
    }
  }

  .container.right-panel-active .sign-up-container {
    transform: translateX(100%);
    opacity: 1;
    z-index: 5;
    animation: show 0.6s;
  }

  .container.right-panel-active .sign-in-container {
    transform: translateX(100%);
  }

  .container.right-panel-active .overlay-container {
    transform: translateX(-100%);
  }

  .container.right-panel-active .overlay {
    transform: translateX(50%);
  }
  .container.right-panel-active .overlay-left {
    transform: translateX(0);
  }

  .container.right-panel-active .overlay-right {
    transform: translateX(20%);
  }

  .social-container{
    .svg-icon{
      color:#000000;
    }
  }
  .pay-error{
    width: 200px;
    height: 200px;
    position: absolute;
    top: 79px;
    left: 50px;
    background-color: rgba(255,255,255,0.9);
    text-align: center;
    color: #000000;
  }
  .pay-expired{
    width: 200px;
    height: 220px;
    position: absolute;
    bottom: 40px;
    background-color: rgba(255,255,255,0.9);
    text-align: center;
    color: #000000;
  }
  .pay-success{
    width: 200px;
    height: 200px;
    position: absolute;
    top: 79px;
    left: 50px;
    line-height: 200px;
    background: #fff;
    text-align: center;
    color: #67C23A;
  }
}
</style>
